// extracted by mini-css-extract-plugin
export default {"NavBack":"NavBack-module__NavBack__pkZ2vj1","Container":"NavBack-module__Container__BM6WDUa","Link":"NavBack-module__Link__sAgUqiy"};